import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import type { BlogPostBannerResult } from '../../data/BlogPostFragment'
import { CardSwiper } from '../swiper/CardSwiper'
import { ArticleBanner } from './ArticleBanner'
import { BlogCarouselCard } from './BlogCarouselCard'
import style from './BlogPostGroup.module.sass'
import { Button } from './Button'
import { Hidden } from './Hidden'
import { TagRow } from './TagRow'
import { Title } from './Title'

type BlogPostGroupProps = {
	category?: string
	blogPosts: BlogPostBannerResult[]
	title?: string
}

export const BlogPostGroup: FunctionComponent<BlogPostGroupProps> = ({ category, blogPosts, title }) => {
	const translate = useTranslate()

	return (
		<>
			<div className={style.header}>
				<Title
					title={
						title ?? (
							<>
								<Translation tr="blogPostGroup.title" />
								&nbsp;<span className={style.greenColor}>{category}</span>
							</>
						)
					}
					hasButton
					buttonLabel={translate('blogPostSection.button.recommendation.more')}
					buttonUrl={InternalLink.BlogPosts}
				/>
			</div>
			<div className={style.content}>
				<Hidden breakpoint="mobileDown" isGridVisible>
					{blogPosts.length > 1 ? (
						<CardSwiper>
							{blogPosts.map((blogPost) => (
								<BlogCarouselCard
									key={blogPost.id}
									title={blogPost.title}
									lead={blogPost.lead}
									url={`${InternalLink.BlogPost}${blogPost.slug}`}
									imageUrl={blogPost?.image?.url}
								/>
							))}
						</CardSwiper>
					) : (
						<ArticleBanner
							title={blogPosts[0].title ?? 'Článek'}
							buttonLabel={translate('listingBlogPosts.button')}
							lead={blogPosts[0].lead}
							href={`${InternalLink.BlogPost}${blogPosts[0].slug}`}
							imageUrl={blogPosts[0].image?.url ?? '/images/placeholder.webp'}
							tagContent={
								blogPosts[0].tags && blogPosts[0].tags?.length > 0 ? <TagRow tags={blogPosts[0].tags} /> : undefined
							}
						/>
					)}
				</Hidden>
				<Hidden breakpoint="mobileUp">
					<div className={style.mobileGrid}>
						{blogPosts
							.map((blogPost) => (
								<BlogCarouselCard
									key={blogPost.id}
									title={blogPost.title}
									lead={blogPost.lead}
									url={`${InternalLink.BlogPost}${blogPost.slug}`}
									imageUrl={blogPost?.image?.url}
								/>
							))
							.slice(0, 4)}
					</div>
					<div className={style.buttonWrapper}>
						<Button
							label={translate('blogPostSection.button.recommendation.more')}
							type={{ variant: 'underlinedGrey' }}
							url={InternalLink.BlogPosts}
						/>
					</div>
				</Hidden>
			</div>
		</>
	)
}
